import styled from 'styled-components';
import getColour from '@lendi-ui/commons/colours';
import { mb, p } from '@lendi-ui/spacing';
import { body, link } from '@lendi-ui/typography';

import { materialCard, Stack } from '@funnels/ui-components';

export const Container = styled.div<{ isDisabled: boolean; isSelected: boolean }>`
  ${materialCard}
  ${(props) =>
    props.isDisabled
      ? `
          cursor: not-allowed;
        `
      : `
          cursor: pointer;
        `}
  border: 1px solid ${(props) => (props.isSelected ? getColour('interaction', 'main') : 'transparent')};
  box-sizing: border-box;
  min-height: 120px;
  background-color: ${(props) => (props.isSelected ? getColour('fill', 'selected') : getColour('fill', 'main'))};
  ${p('sm')}
  ${mb('sm')}
  position: relative;
`;

export const ShowHideButton = styled.button`
  ${link({ size: 'xxs' })}
  background: none;
  border: none;
  font-weight: bold;
  ${p('nil')}
  outline: none;
  text-decoration: none;
  text-transform: uppercase;

  &:hover,
  &:active,
  &:focus {
    text-decoration: none;
  }
`;

export const NameContainer = styled(Stack)`
  justify-content: space-between;
  flex-wrap: nowrap;
  width: 100%;
  ${body({ size: 'xs' })}
  ${mb('nil')}
`;

export const Name = styled.div`
  max-width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const DateLabel = styled.span`
  color: ${() => getColour('text', 'subtle')};
`;
